/**
 * Pathway id vocabulary (PROD-642 Sprint 2.2 extraction).
 *
 * Extracted from `pathway.store.ts` so non-store consumers (the FHIR
 * mapper, the demo seed, the read-through cache) can import the closed
 * pathway-id enum without dragging in the Zustand store module. The
 * store re-exports these names so existing callers keep working.
 *
 * Brand Patch (vault: 06-decisions/care-pathway-studio/2026-05-06-brand-
 * and-naming-cleanup-patch.md): legacy TLP1-TLP4 identifiers were
 * replaced with slug-cased clinical pathway names. The internal version
 * id (`tlp{n}-...-v1`) is retained because it surfaces in telemetry +
 * override fixtures.
 *
 * HC5: zero em / en dashes.
 */
export const PATHWAY_IDS = [
  'cardiometabolic-pathway',
  'hrt-pathway',
  'metabolic-syndrome-pathway',
  'cvd-prevention-pathway',
] as const;

export type PathwayId = (typeof PATHWAY_IDS)[number];

/** Map a `PathwayId` slug to its versioned wire id. Pure function. */
export function pathwayIdFor(id: PathwayId): string {
  switch (id) {
    case 'cardiometabolic-pathway':
      return 'tlp1-glp1-v1';
    case 'hrt-pathway':
      return 'tlp2-hrt-v1';
    case 'metabolic-syndrome-pathway':
      return 'tlp3-metsyn-v1';
    case 'cvd-prevention-pathway':
      return 'tlp4-cvd-v1';
  }
}
